export class ContaBancaria {}
